import React from 'react';

const useInputTitle = (props) => {
    const [title, setTitle] = React.useState('');
    const onChange = React.useCallback((e) => {
        var _a;
        setTitle(e.target.value);
        (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, e);
    }, [props]);
    return { onChange, title };
};

export { useInputTitle };
//# sourceMappingURL=useInputTitle.js.map
